var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('ProductSpecification',{attrs:{"color":_vm.color,"productSpecification":_vm.data.content.product.specification}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }